import React from 'react'

const GptMovieSuggestion = () => {
  return (
    <div>GptMovieSuggestion</div>
  )
}

export default GptMovieSuggestion